var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{class:_vm.classes},[_c('img',{staticStyle:{"width":"120px","height":"39px"},attrs:{"src":_vm.url,"alt":"lukoil logo"}}),(!_vm.isBitumMaterials)?_c('div',{staticClass:"logo__text"},[_vm._v("\n            "+_vm._s(_vm.$t("академия"))+"\n        ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }